import { Alert, AlertProps } from '@mui/material'
import { PrometheusAlert, RuuviTag } from '../types'
import { useTranslation } from 'react-i18next'
import { NotificationsActive } from '@mui/icons-material'
import BlinkingComponent from './BlinkingComponent'

export interface RuuviTagActiveAlertsWarningProps extends Omit<
  AlertProps,
  'children' | 'severity' | 'icon'
> {
  ruuviTag: RuuviTag
  alerts: PrometheusAlert[]
  loading?: boolean
}

export default function RuuviTagActiveAlertsWarning({
  ruuviTag: _,
  alerts,
  ...props
}: RuuviTagActiveAlertsWarningProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation('common')

  return (
    <>
      {alerts.length > 0 && (
        <BlinkingComponent>
          <Alert severity="warning" icon={<NotificationsActive />} {...props}>
            {t('deviceHasActiveAlerts')}
          </Alert>
        </BlinkingComponent>
      )}
    </>
  )
}
